import { z } from 'zod'
import { codePointLength, trimForValidate } from '@/utils/stringLength'

/** 实践上限：RFC 5321 本地部最长 64，总长可达 254；表单防误填取 100 */
export const EMAIL_LIMITS = {
  min: 3,
  max: 100,
} as const

/** 电子邮箱（必填） */
export const emailSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .min(1, '请输入邮箱')
      .min(EMAIL_LIMITS.min, `邮箱至少 ${EMAIL_LIMITS.min} 个字符`)
      .max(EMAIL_LIMITS.max, `邮箱不能超过 ${EMAIL_LIMITS.max} 个字符`)
      .email('请输入正确的邮箱格式'),
  )

/** 选填邮箱：空值通过 */
export const optionalEmailSchema = z
  .string()
  .transform(trimForValidate)
  .pipe(
    z
      .string()
      .refine(
        (v) => !v || codePointLength(v) <= EMAIL_LIMITS.max,
        `邮箱不能超过 ${EMAIL_LIMITS.max} 个字符`,
      )
      .refine(
        (v) =>
          !v || (codePointLength(v) >= EMAIL_LIMITS.min && z.string().email().safeParse(v).success),
        '请输入正确的邮箱格式',
      ),
  )
